import { render, staticRenderFns } from "./CompetenciesView.vue?vue&type=template&id=1a070808"
import script from "./CompetenciesView.vue?vue&type=script&lang=js"
export * from "./CompetenciesView.vue?vue&type=script&lang=js"
import style0 from "./CompetenciesView.vue?vue&type=style&index=0&id=1a070808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports